import { render, staticRenderFns } from "./ProfileMenuMspForsageOperatorMobile.vue?vue&type=template&id=6d9ce549&scoped=true&"
import script from "./ProfileMenuMspForsageOperatorMobile.vue?vue&type=script&lang=js&"
export * from "./ProfileMenuMspForsageOperatorMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9ce549",
  null
  
)

export default component.exports